import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { ChildGenderEnum } from '@sola/schema/dotcom/children/childUtilityInterfaces.ts';
import type { GraphQLCommitmentParticipant } from '@sola/schema/dotcom/supporters/schema.generated.ts';
export type UsePrimaryCtaDepartureArgs = {
  participants: GraphQLCommitmentParticipant[];
};
export const usePrimaryCtaDeparture = t0 => {
  const $ = _c(16);
  const {
    participants
  } = t0;
  const {
    t
  } = useTranslation("my");
  const count = participants.length;
  const gender = participants[0]?.gender;
  const genderContext = gender === ChildGenderEnum.Male || gender === ChildGenderEnum.Female ? gender : undefined;
  const t1 = participants[0]?.name ?? "";
  const t2 = participants[1]?.name ?? "";
  const t3 = count === 2 ? "two" : genderContext;
  let t4;
  if ($[0] !== count || $[1] !== t || $[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
    t4 = t("my:primaryCtaDeparture.title", {
      name: t1,
      name2: t2,
      count,
      context: t3
    });
    $[0] = count;
    $[1] = t;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const title = t4;
  let t5;
  if ($[6] !== t) {
    t5 = t("my:primaryCtaDeparture.subtitle");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const subtitle = t5;
  let t6;
  if ($[8] !== t) {
    t6 = t("my:primaryCtaDeparture.cta");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const cta = t6;
  let t7;
  if ($[10] !== count || $[11] !== cta || $[12] !== subtitle || $[13] !== t || $[14] !== title) {
    t7 = {
      t,
      count,
      title,
      subtitle,
      cta
    };
    $[10] = count;
    $[11] = cta;
    $[12] = subtitle;
    $[13] = t;
    $[14] = title;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};